<template>
  <div>
    <table class="prop-table mb-2">
      <tr>
        <th>Participant amount</th>
        <td>{{stat.participantAmount | getFormattedNumber}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TmntChampsStat',

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
};
</script>
